module.exports = __webpack_public_path__ + "img/prepaid.231347f.svg";